import React from 'react';
import { CalendarClock, Star, AlertTriangle, CalendarPlus, Printer } from 'lucide-react';
import { czDate } from '../../utils/upgradesApi';

// "Termín a posádka": when the trip is, who goes and whether somebody is already booked.
const UpgradeScheduleCard = ({ job, form, set, users, locked, dirty, onError }) => {
  const inCrew = (userId) => form.crew.some((c) => c.user_id === userId);
  const toggle = (userId) => {
    if (inCrew(userId)) {
      const rest = form.crew.filter((c) => c.user_id !== userId);
      set('crew', rest.length && !rest.some((c) => c.is_lead) ? rest.map((c, i) => ({ ...c, is_lead: i === 0 })) : rest);
    } else {
      set('crew', [...form.crew, { user_id: userId, is_lead: form.crew.length === 0 }]);
    }
  };
  const makeLead = (userId) => set('crew', form.crew.map((c) => ({ ...c, is_lead: c.user_id === userId })));
  const changeStart = (value) => {
    set('planned_start', value);
    if (value && (!form.planned_end || form.planned_end < value)) set('planned_end', value);
  };
  const needSaved = (e) => { if (dirty) { e.preventDefault(); onError('Nejdřív uložte změny, soubor se vytváří z uložených údajů.'); } };

  const crewConflicts = job.conflicts?.crew || [];
  const machineConflicts = job.conflicts?.machines || [];

  return (
    <section className="dlv-card" aria-labelledby="upg-schedule">
      <h2 id="upg-schedule" className="upg-card-title"><CalendarClock size={18} /> Termín a posádka</h2>
      <div className="upg-fields">
        <div>
          <label className="dlv-label" htmlFor="upg-start">Výjezd od</label>
          <input id="upg-start" className="dlv-input" type="date" value={form.planned_start} disabled={locked} onChange={(e) => changeStart(e.target.value)} />
        </div>
        <div>
          <label className="dlv-label" htmlFor="upg-end">Výjezd do</label>
          <input id="upg-end" className="dlv-input" type="date" min={form.planned_start || undefined} value={form.planned_end} disabled={locked} onChange={(e) => set('planned_end', e.target.value)} />
        </div>
        <div>
          <label className="dlv-label" htmlFor="upg-time">Příjezd (čas)</label>
          <input id="upg-time" className="dlv-input" type="time" value={form.arrival_time} disabled={locked} onChange={(e) => set('arrival_time', e.target.value)} />
        </div>
        <div className="full">
          <span className="dlv-label">Kdo jede <span style={{ textTransform: 'none', letterSpacing: 0, fontWeight: 500 }}>(hvězdička = vedoucí výjezdu)</span></span>
          <div className="upg-crew" role="group" aria-label="Posádka">
            {users.map((u) => {
              const on = inCrew(u.id);
              const lead = form.crew.find((c) => c.user_id === u.id)?.is_lead;
              return (
                <span key={u.id} className="upg-person-wrap">
                  <button type="button" className="upg-person" aria-pressed={on} disabled={locked} onClick={() => toggle(u.id)}>{u.name}</button>
                  {on && (
                    <button type="button" className={`upg-star ${lead ? 'upg-star--on' : ''}`} disabled={locked} onClick={() => makeLead(u.id)}
                      aria-pressed={Boolean(lead)} aria-label={lead ? `${u.name} je vedoucí výjezdu` : `Nastavit ${u.name} jako vedoucího výjezdu`}>
                      <Star size={15} fill={lead ? 'currentColor' : 'none'} />
                    </button>
                  )}
                </span>
              );
            })}
          </div>
        </div>
      </div>

      {(crewConflicts.length > 0 || machineConflicts.length > 0) && (
        <div style={{ marginTop: 14 }}>
          {crewConflicts.map((c) => (
            <div key={`${c.user_id}-${c.upgrade_id}`} className="upg-banner upg-banner--red" role="alert">
              <AlertTriangle size={16} /><span><strong>{c.name}</strong> už jede {czDate(c.planned_start)}{c.planned_end && c.planned_end !== c.planned_start ? ` – ${czDate(c.planned_end)}` : ''} k zákazníkovi {c.customer_name} ({c.number}).</span>
            </div>
          ))}
          {machineConflicts.map((m) => (
            <div key={`${m.machine_id}-${m.upgrade_id}`} className="upg-banner" role="status">
              <AlertTriangle size={16} /><span>Na trenažéru SN {m.serial_number} je rozpracovaná i úprava {m.number} ({m.customer_name}).</span>
            </div>
          ))}
        </div>
      )}

      <div className="upg-tools">
        <a className="dlv-btn upg-sm" href={`/api/upgrades/${job.id}/trip-sheet.pdf`} target="_blank" rel="noopener noreferrer" onClick={needSaved}><Printer size={16} /> Výjezdový list (PDF)</a>
        {job.planned_start && (
          <a className="dlv-btn upg-sm" href={`/api/upgrades/${job.id}/event.ics`} onClick={needSaved}><CalendarPlus size={16} /> Přidat do kalendáře</a>
        )}
      </div>
    </section>
  );
};

export default UpgradeScheduleCard;
